import { getIsSalesSpaceChannelType } from '../../channel/channelSelectors';
import { getIsAgent } from '../../currentUser/currentUserSelectors';
import { channelRemoved } from '../channelsSlice';

const handleChannelRemoved =
  ({ channelId }) =>
  async (dispatch, getState) => {
    const isSalesSpace = getIsSalesSpaceChannelType(channelId)(getState());
    const isAgent = getIsAgent(getState());

    // remove channel only if it's not unjoined agent from the sales-space;
    if (!(isSalesSpace && isAgent)) {
      dispatch(channelRemoved({ channelId }));
    }
  };

export default handleChannelRemoved;
